function easyResponsiveTabs(element, options = {}) {
  const defaults = {
    type: 'default',
    width: 'auto',
    fit: true,
    closed: false,
    tabidentify: '',
    activetab_bg: 'white',
    inactive_bg: '#F5F5F5',
    active_border_color: '#c1c1c1',
    active_content_border_color: '#c1c1c1',
    activate: function () {}
  };

  const opt = Object.assign({}, defaults, options);
  const container = typeof element === 'string' ? document.querySelector(element) : element;
  if (!container) return;

  const tabidentify = opt.tabidentify;
  const tabList = container.querySelector(`ul.resp-tabs-list.${tabidentify}`);
  const tabItems = container.querySelectorAll(`ul.resp-tabs-list.${tabidentify} li`);
  const tabContents = container.querySelectorAll(`.resp-tabs-container.${tabidentify} > div`);
  const tabsContainer = container.querySelector(`.resp-tabs-container.${tabidentify}`);
  const historyApi = !!(window.history && window.history.replaceState);

  container.style.display = 'block';
  container.style.width = opt.width;
  if (tabsContainer) tabsContainer.style.borderColor = opt.active_content_border_color;
  if (opt.fit) container.style.width = '100%';

  tabItems.forEach(li => {
    li.classList.add('resp-tab-item', tabidentify);
    li.style.backgroundColor = opt.inactive_bg;
  });

  tabContents.forEach(div => {
    div.classList.add('resp-tab-content', tabidentify);
    div.style.borderColor = opt.active_border_color;
    // div.style.overflow = 'hidden';
    // div.style.maxHeight = '0';
    // div.style.display = 'none';
  });

  container.classList.add('resp-easy-tabs', tabidentify);

  tabContents.forEach(content => {
    const h2 = document.createElement('h2');
    h2.className = `resp-accordion ${tabidentify}`;
    h2.setAttribute('role', 'tab');
    h2.style.backgroundColor = opt.inactive_bg;
    h2.style.borderColor = opt.active_border_color;
    content.parentNode.insertBefore(h2, content);
  });

  const accHeaders = container.querySelectorAll(`.resp-accordion.${tabidentify}`);
  accHeaders.forEach((header, i) => {
    header.innerHTML = `<span class='resp-arrow'></span>${tabItems[i]?.innerHTML || ''}`;
    header.setAttribute('aria-controls', `${tabidentify}_tab_item-${i}`);
  });
  tabItems.forEach((item, i) => item.setAttribute('aria-controls', `${tabidentify}_tab_item-${i}`));
  tabContents.forEach((content, i) => content.setAttribute('aria-labelledby', `${tabidentify}_tab_item-${i}`));

  let activeIndex = 0;
  const hash = window.location.hash;
  if (hash) {
    const matches = hash.match(new RegExp(container.id + "([0-9]+)"));
    if (matches && matches[1]) {
      activeIndex = parseInt(matches[1], 10) - 1;
      if (activeIndex >= tabItems.length) activeIndex = 0;
    }
  }

  function isAccordionMode() {
    return !tabList || window.getComputedStyle(tabList).display === 'none';
  }

  // function slideDown(el) {
  //   el.style.display = 'block';
  //   el.style.transition = 'max-height 0.35s ease';
  //   const height = el.scrollHeight + 'px';
  //   el.style.maxHeight = '0';
  //   requestAnimationFrame(() => (el.style.maxHeight = height));
  //   setTimeout(() => (el.style.maxHeight = 'none'), 350);
  // }

  // function slideUp(el) {
  //   el.style.transition = 'max-height 0.35s ease';
  //   const height = el.scrollHeight + 'px';
  //   el.style.maxHeight = height;
  //   requestAnimationFrame(() => (el.style.maxHeight = '0'));
  //   setTimeout(() => (el.style.display = 'none'), 350);
  // }

  /* SLIDE UP */
    let slideUp = (target, duration=350) => {
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      window.setTimeout( () => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            //alert("!");
      }, duration);
  }

  /* SLIDE DOWN */
  let slideDown = (target, duration=350) => {
      target.style.removeProperty('display');
      let display = window.getComputedStyle(target).display;
      if (display === 'none') display = 'block';
      target.style.display = display;
      let height = target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.offsetHeight;
      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = "height, margin, padding";
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      window.setTimeout( () => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
  }

  function activateTab(index, skipHistory = false) {
    tabItems.forEach(t => {
      t.classList.remove('resp-tab-active');
      t.style.backgroundColor = opt.inactive_bg;
    });
    accHeaders.forEach(a => {
      a.classList.remove('resp-tab-active');
      a.style.backgroundColor = opt.inactive_bg;
    });
    tabContents.forEach(c => {
      c.classList.remove('resp-tab-content-active');
      c.style.display = 'none';
      // c.style.maxHeight = '0';
    });

    const tab = tabItems[index];
    const acc = accHeaders[index];
    const content = tabContents[index];
    if (!tab || !content) return;

    tab.classList.add('resp-tab-active');
    tab.style.backgroundColor = opt.activetab_bg;
    acc.classList.add('resp-tab-active');
    acc.style.backgroundColor = opt.activetab_bg;
    content.classList.add('resp-tab-content-active');

    if (isAccordionMode()) {
      slideDown(content);
    } else {
      content.style.display = 'block';
      content.style.maxHeight = 'none';
      content.style.transition = 'none';
    }

    if (!skipHistory && historyApi) {
      const newHash = `#tab=${tab.id || `${container.id}${index + 1}`}`;
      history.replaceState(null, null, newHash);
    }

    if (typeof opt.activate === 'function') opt.activate.call(tab);
  }

  if (opt.closed !== true) activateTab(activeIndex, true);

  tabItems.forEach((item, i) => {
    item.addEventListener('click', e => {
      e.preventDefault();
      if (!isAccordionMode()) activateTab(i);
    });
  });

  accHeaders.forEach((header, i) => {
    header.addEventListener('click', e => {
      e.preventDefault();
      const content = tabContents[i];
      const isActive = header.classList.contains('resp-tab-active');
      accHeaders.forEach((h, j) => {
        if (i !== j) {
          h.classList.remove('resp-tab-active');
          h.style.backgroundColor = opt.inactive_bg;
          slideUp(tabContents[j]);
        }
      });
      if (!isActive) {
        header.classList.add('resp-tab-active');
        header.style.backgroundColor = opt.activetab_bg;
        slideDown(content);
      } else {
        header.classList.remove('resp-tab-active');
        header.style.backgroundColor = opt.inactive_bg;
        slideUp(content);
      }
    });
  });

  let resizeTimeout;
  function checkMode() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (isAccordionMode()) {
        tabItems.forEach(t => t.removeAttribute('style'));
      } else {
        accHeaders.forEach(h => h.classList.remove('resp-tab-active'));
        tabItems.forEach((t, i) => {
          const content = tabContents[i];
          content.style.transition = 'none';
          if (t.classList.contains('resp-tab-active')) {
            // content.style.display = 'block';
            // content.style.maxHeight = 'none';
          } else {
            // content.style.display = 'none';
            // content.style.maxHeight = '0';
          }
        });
      }
    }, 200);
  }

  checkMode();
  window.addEventListener('resize', checkMode);
}
